(function () {
  'use strict';

  function calculate(price, down, months, annualRate) {
    if (![price, down, months, annualRate].every(Number.isFinite) || price <= 0 || down < 0 || down > price || !Number.isInteger(months) || months < 1 || annualRate < 0) return null;
    var principal = price - down;
    var monthlyInterest = annualRate / 1200;
    var payment = principal === 0 ? 0 : monthlyInterest === 0 ? principal / months : principal * monthlyInterest / -Math.expm1(-months * Math.log1p(monthlyInterest));
    return { principal: principal, down: down, payment: payment, interest: Math.max(0, payment * months - principal), total: payment * months + down };
  }

  function economy(payment, revenue, cost, hours) {
    if (![payment, revenue, cost].every(Number.isFinite) || payment < 0 || revenue < 0 || cost < 0 || revenue > 100000 || cost > 100000) return null;
    var margin = revenue - cost;
    var planned = Number.isFinite(hours) && hours >= 0 && hours <= 744;
    return { margin: margin, coverage: payment === 0 ? 0 : margin > 0 ? Math.ceil(payment / margin * 10 - 1e-10) / 10 : null, balance: planned ? margin * hours - payment : null };
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { calculate: calculate, economy: economy };
  if (typeof document === 'undefined') return;

  function init(root) {
    if (root.dataset.bd70Ready) return;
    var catalogNode = root.querySelector('[data-bd70-catalog]');
    if (!catalogNode) return;
    var get = function (key) { return root.querySelector('[data-bd70-' + key + ']'); };
    var set = function (key, text) { get(key).textContent = text; };
    var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    var decimal = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });
    var model = get('model'), variant = get('variant'), downInput = get('down');
    var timer;
    var catalog;
    try {
      catalog = JSON.parse(catalogNode.textContent).filter(function (product) {
        return product.title && Array.isArray(product.variants) && product.variants.length && product.variants.every(function (item) { return Number.isFinite(item.price) && item.price > 0; });
      });
      if (!catalog.length) throw new Error('No priced products');
    } catch (_) {
      get('loading').textContent = 'Die aktuellen Gerätepreise konnten nicht geladen werden. Bitte nutzen Sie die persönliche Finanzierungsanfrage unten.';
      return;
    }

    function value(input) { return input.value.trim() === '' || input.validity.badInput ? NaN : Number(input.value); }
    function valid(input, validState) { input.setAttribute('aria-invalid', String(!validState)); }
    function variantTitle(item) { return item.title === 'Default Title' ? 'Standardausführung' : item.title; }
    function populateVariants() {
      var product = catalog[Number(model.value)];
      variant.replaceChildren();
      product.variants.forEach(function (item, index) { variant.add(new Option(variantTitle(item), String(index))); });
    }
    function update(announce) {
      var product = catalog[Number(model.value)];
      var item = product.variants[Number(variant.value)];
      var price = item.price / 100;
      var withDown = root.querySelector('input[name="bd70-down-mode"]:checked').value === 'yes';
      get('down-field').hidden = !withDown;
      downInput.disabled = !withDown;
      downInput.max = String(price);
      var down = withDown ? value(downInput) : 0;
      var downValid = Number.isFinite(down) && down >= 0 && down <= price;
      valid(downInput, downValid);
      var result = calculate(price, down, Number(get('term').value), 6);
      set('price', euro.format(price));
      set('stock', item.available ? 'Preis der ausgewählten Ausführung. Lieferbarkeit und Finanzierung werden im Angebot bestätigt.' : 'Diese Ausführung ist derzeit nicht direkt verfügbar. Lieferbarkeit bitte individuell anfragen.');
      set('product-name', product.title);
      set('variant-name', variantTitle(item));
      var img = get('image');
      if (product.image) {
        if (img.getAttribute('src') !== product.image) img.setAttribute('src', product.image);
        img.hidden = false;
      } else { img.hidden = true; img.removeAttribute('src'); }
      get('error').hidden = !!result;
      set('error', result ? '' : 'Bitte geben Sie eine Anzahlung zwischen 0 € und ' + euro.format(price) + ' ein.');
      get('finance-result').hidden = !result;
      get('finance-empty').hidden = !!result;
      if (result) {
        set('rate', euro.format(result.payment));
        set('principal', euro.format(result.principal));
        set('down-result', euro.format(result.down));
        set('interest', euro.format(result.interest));
        set('total', euro.format(result.total));
      }

      var revenueInput = get('revenue'), costInput = get('cost'), hoursInput = get('hours');
      var revenue = value(revenueInput), cost = value(costInput), hours = value(hoursInput);
      var revenueValid = Number.isFinite(revenue) && revenue >= 0 && revenue <= 100000;
      var costValid = Number.isFinite(cost) && cost >= 0 && cost <= 100000;
      var hoursEmpty = hoursInput.value === '' && !hoursInput.validity.badInput;
      var hoursValid = Number.isFinite(hours) && hours >= 0 && hours <= 744;
      valid(revenueInput, revenueValid || (revenueInput.value === '' && !revenueInput.validity.badInput));
      valid(costInput, costValid || (costInput.value === '' && !costInput.validity.badInput));
      valid(hoursInput, hoursEmpty || hoursValid);
      var econ = result ? economy(result.payment, revenue, cost, hours) : null;
      get('economy-details').hidden = !econ;
      get('monthly').hidden = !econ || econ.balance === null;
      var explanation;
      set('cover-value', '—');
      if (!result) explanation = 'Bitte korrigieren Sie zuerst die Finanzierungseingaben.';
      else if (!econ) explanation = 'Bitte geben Sie Ihren Netto-Stundenumsatz und Ihre Stundenkosten jeweils zwischen 0 und 100.000 € ein. Leere Felder werden nicht als 0 € gerechnet.';
      else {
        set('margin', euro.format(econ.margin) + ' / h');
        if (result.payment === 0) {
          set('cover-value', 'Keine Rate');
          explanation = 'Die Anzahlung deckt den gesamten Gerätepreis. Daraus folgt keine Aussage zur Wirtschaftlichkeit oder zur Rückgewinnung Ihrer Investition.';
        } else if (econ.margin <= 0) {
          set('cover-value', 'Nicht gedeckt');
          explanation = 'Bei diesen Eingaben bleibt pro Stunde kein positiver Beitrag zur Monatsrate. Mehr Einsatzstunden allein decken sie damit nicht.';
        } else {
          set('cover-value', decimal.format(econ.coverage) + ' h / Monat');
          explanation = 'Abrechenbare Stunden zur Deckung der Beispielrate, nach Ihren eingegebenen Stundenkosten. Auf volle Zehntelstunden aufgerundet.';
          if (econ.coverage > 744) explanation += ' Das überschreitet selbst 744 Stunden im Monat und ist für ein einzelnes Gerät nicht umsetzbar.';
        }
        if (econ.balance !== null) {
          set('balance', euro.format(econ.balance));
          get('monthly').dataset.negative = String(econ.balance < 0);
        }
      }
      if (!hoursEmpty && !hoursValid) explanation += ' Geplante Monatsstunden bitte zwischen 0 und 744 eingeben.';
      set('cover-text', explanation);
      if (announce) {
        clearTimeout(timer);
        timer = setTimeout(function () { set('announcement', (result ? 'Beispielrate: ' + euro.format(result.payment) + ' pro Monat. ' : 'Finanzierungseingaben prüfen. ') + get('cover-value').textContent + '. ' + explanation); }, 400);
      }
    }

    catalog.forEach(function (product, index) { model.add(new Option(product.title, String(index))); });
    populateVariants();
    update(false);
    root.dataset.bd70Ready = 'true';
    get('ui').hidden = false;
    get('loading').hidden = true;
    model.addEventListener('change', function () { populateVariants(); update(true); });
    root.addEventListener('input', function (event) { if (event.target.matches('input')) update(true); });
    root.addEventListener('change', function (event) { if (event.target !== model && event.target.matches('select, input')) update(true); });
  }
  document.querySelectorAll('[data-bd70]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-bd70]').forEach(init); });
})();
